import { IconGift } from '../../icons';
export const GiftFlag = () => {
  return <span className='absolute bottom-0 left-0 top-33 z-10 h-fit rounded-br rounded-tr bg-primary-main px-3 py-1' data-sentry-component="GiftFlag" data-sentry-source-file="gift-flag.tsx">
            <IconGift className='w-4 text-text-white' data-sentry-element="IconGift" data-sentry-source-file="gift-flag.tsx" />
        </span>;
};